var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2 7.842v9.05l5.21-5.698L3.2 7.842zm6.234 4.01L3.996 17.8H20.004l-5.439-5.947-1.7 1.093a1.6 1.6 0 01-1.73 0l-1.7-1.093zm6.155-.658l5.211 5.698v-9.05l-5.21 3.352zm5.05-4.675l-8.423 5.418a.4.4 0 01-.432 0L3.36 6.519A.799.799 0 014 6.2h16c.261 0 .493.125.64.319zM4 5a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-2-2H4z",
    fill: "#CCC"
  })));
}
export default SvgEmail;